import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { useLocation } from 'react-router-dom'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'

import makeStyles from '@material-ui/core/styles/makeStyles'

import { usePrice } from '../../../../../shared/contexts/PriceContext'

import useUserClient from '../../../../../clients/UserClient/useUserClient'

import {
  ButtonLight,
  ButtonGradient,
} from '../../../../../shared/components'
import CollapsePrice from '../../../../../shared/components/CollapsePrice/CollapsePrice'

const useStyles = makeStyles((theme) => ({
  buttonsStep: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& .MuiBox-root': {
      minWidth: 190,
      [theme.breakpoints.down('xs')]: {
        marginTop: 5,
        marginLeft: 5,
        minWidth: 115,
      },
    },
  },
  label: {
    color: theme.palette.text.quaternary,
    fontWeight: 'bold',
  },
}))

const Insured = forwardRef((props, ref) => {
  const classes = useStyles()
  const userClient = useUserClient()
  const { state } = useLocation()

  const {
    quote,
    checked,
    handleStep,
    handleNext,
    handlePrevious,
  } = props

  const {
    onNext,
    actionNext,
    setNamePolicyHolder,
    judicialGuaranteeLabor,
    setJudicialGuaranteeLabor,
  } = usePrice()

  const tomadorName = quote?.PolicyHolder?.Name ?? state?.tomadorName ?? ''
  const tomadorDocument = quote?.PolicyHolder?.Document ?? state?.tomadorDocument ?? ''

  useEffect(() => {
    if (tomadorName) {
      setNamePolicyHolder(tomadorName)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tomadorName])

  useImperativeHandle(ref, () => ({
    onSubmit: () => new Promise((resolve) => {
      const values = {
        ...judicialGuaranteeLabor,
        policyHolder: {
          name: tomadorName,
          document: tomadorDocument,
        },
      }

      userClient().getClientByUserLogged().then((response) => {
        const filterNotLead = response?.data?.filter((item) => item?.lead === false)
        const filterNomination = filterNotLead
          ?.filter((item) => item?.cpfcnpj === values.policyHolder.document)
        if (filterNomination?.length > 0) {
          setJudicialGuaranteeLabor({ ...values, ClientIsNominated: true })
        } else {
          setJudicialGuaranteeLabor({ ...values, ClientIsNominated: false })
        }
      }, () => {
        setJudicialGuaranteeLabor({ ...values })
      })

      if (actionNext) {
        onNext(values)
      }

      resolve(undefined)
    }),
  }))

  const policyHolderLabel = 'Tomador'

  return (
    <>
      <CollapsePrice
        checked={checked}
        handleEdit={handleStep}
        hiddenEdit={isEmpty(quote?.PolicyHolder)}
        title="Dados do Tomador"
        subtitle="Caso queira alterar o tomador, retorne à etapa de Dados do Produto"
      >
        <Grid container spacing={5}>
          <Grid item sm={6} xs={12}>
            <FormControl fullWidth>
              <label htmlFor="policyHolderLabel" className={classes.label}>{policyHolderLabel}</label>
              <Input
                fullWidth
                id="name"
                color="secondary"
                disabled
                value={tomadorName}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.buttonsStep}>
              <Box>
                <ButtonLight
                  onClick={handlePrevious}
                  title="Voltar"
                >
                  Voltar
                </ButtonLight>
              </Box>
              <Box ml={4}>
                <ButtonGradient
                  onClick={handleNext}
                  title="Continuar"
                >
                  Continuar
                </ButtonGradient>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CollapsePrice>
    </>
  )
})

Insured.propTypes = {
  quote: PropTypes.any,
  checked: PropTypes.bool,
  handleStep: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
}

Insured.defaultProps = {
  checked: false,
  quote: undefined,
}

export default Insured
